module.exports = __webpack_public_path__ + "images/da53d456c27f4f6055016021bd636f56.svg";